import { Component, Input, OnInit } from '@angular/core';
import { ShareType } from 'src/app/models/social';

@Component({
  selector: 'app-share-button',
  templateUrl: './share-button.component.html',
  styleUrls: ['./share-button.component.scss'],
})
export class ShareButtonComponent implements OnInit {
  /**
   * Determines which social links will appear
   */
  @Input() include!: ShareType[];
  /**
   * Sets the title of the shared link
   */
  @Input() title: string;
  /**
   * Sets the description of the shared link
   */
  @Input() description: string;
  /**
   * Sets the url of the shared link
   */
  @Input() url: string;

  constructor() {}

  ngOnInit() {}
}
